import {inject} from '@angular/core';
import {Router} from '@angular/router';
import {filter, first} from 'rxjs';
import {AuthService} from '../../services/auth.service';

export const authPageGuard = () => {
  const router = inject(Router);
  const authService = inject(AuthService);

  return authService
    .isAgentLoggedIn()
    .pipe(
      first(),
      filter((isLoggedIn: boolean) => isLoggedIn),
    )
    .subscribe(() => router.navigate(['/', 'dashboard', 'proposals']));
};
